import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class VendaService {

  constructor(
    private http: HttpClient
  ) { }

  obterVenda(id: string) {
    return this.http
      .get(urls.apiBase + '/Vendas/ObterPorId?id=' + id);
  }

  atualizarVenda(data: any) {
    return this.http
      .put(urls.apiBase + '/Vendas/Atualizar', data);
  }

  atualizarCartao(id: string, cartaoId: string) {
    return this.http
      .put(urls.apiBase + '/Vendas/AtualizarCartao?id=' + id + '&cartaoId=' + cartaoId, null);
  }

  obterCobrancasPorVendaId(id: string) {
    return this.http
      .get(urls.apiBase + '/Vendas/ObterCobrancasPorVendaId?id=' + id);
  }

  processarVendaTransparente(data: any) {
    return this.http
      .post(urls.apiBase + '/Vendas/ProcessarVendaTransparente', data);
  }

  obterPorClienteId(clienteId: any) {
    return this.http
      .get(urls.apiBase + '/Vendas/ObterPorClienteId?clienteId=' + clienteId);
  }

  obterPorContaId(contaId: string, dataInicio: string, dataFim: string, numeroPagina: number) {
    const quantidadePorPagina = 100000;

    return this.http
      .get(`${urls.apiBase}/Vendas/ObterPorContaId?contaId=${contaId}&dataInicio=${dataInicio}&dataFim=${dataFim}&numeroPagina=${numeroPagina}&quantidadePorPagina=${quantidadePorPagina}`);
  }

  cancelarVenda(vendaId: string) {
    return this.http
      .put(urls.apiBase + '/Vendas/Cancelar?id=' + vendaId, null);
  }

  cancelarVendaTerminal(vendaId: string) {
    return this.http
      .delete(urls.apiBase + '/Vendas/CancelarVendaTerminal?vendaId=' + vendaId);
  }
}
